import React from 'react';
import '../App.css';
import Headerappprivateadmin from './/headerappprivateadmin'
import { Bodyapphomebodyadminsustituciones} from './/bodyapphomebodyadminsustituciones'
import { Footerappprivateadmin } from './/footerappprivateadmin'
import withRouter from './/withRouter'
class Bodyappadminsustituciones extends React.Component {
    constructor(props){
        super(props);
    }
  
  componentDidMount(){
    if(window.localStorage.getItem('MY_APP_STATE_AUTHCODE') == ''){
       window.location = ('/')
    }
  }

  render(){  
    return (  
      <div className="App">        
        <Headerappprivateadmin/>
        <Bodyapphomebodyadminsustituciones/>
        <Footerappprivateadmin/>
      </div>
    );
  }
}
export default withRouter(Bodyappadminsustituciones);